export const setConfiguration = (configuration) => ({
  type: 'SET_CONFIGURATION',
  configuration
});
